import {ChangeDetectionStrategy, Component, inject, signal} from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import { AuthService } from '../../services/auth-service';
import { ToastrService } from '../../../shared/services/toastr-service';
import { Router } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatSpinner } from '@angular/material/progress-spinner';
import { Subscription } from 'rxjs';
import { MatTooltip } from '@angular/material/tooltip';


@Component({
  selector: 'app-login-component',
  templateUrl: './login-component.html',
  styleUrl: './login-component.css',
  imports: [MatButtonModule, MatTooltip],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent {
 readonly dialog = inject(MatDialog);

 currentSygmaSite = localStorage.getItem('currentSygmaSite')??'SYGMA'

 color = ""

 constructor(){

 }

 ngOnInit(): void {
  this.color = localStorage.getItem('currentSygmaSiteColor')??'default'
  console.log(this.color);
  
  this.openModal('1000ms', '0ms')
 }

  openModal(enterAnimationDuration: string, exitAnimationDuration: string): void {
    this.dialog.open(LoginConponentModal, {
      width: '600px',
      maxHeight: 'fit-content',
      enterAnimationDuration,
      exitAnimationDuration,
      disableClose : true,
      position : {
        right: '8%'
      }
    });
  }

  ngOnDestroy(): void {
    this.dialog.closeAll()
  }
}

@Component({
  selector: 'login-component-modal',
  templateUrl: 'login-component-modal.html',
  styleUrl: './login-component-modal.css',
  imports: [
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    ReactiveFormsModule,
    MatCardModule,
    MatSpinner
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class LoginConponentModal {
  readonly dialogRef = inject(MatDialogRef<LoginConponentModal>);

  loginForm : FormGroup = new FormGroup({})
  loading = signal<boolean>(false)
  hidePassword = true;

  loginSubscription !: Subscription

  currentSygmaSite = localStorage.getItem('currentSygmaSite')??'SYGMA'

  constructor(
      private fb : FormBuilder,
      private authService : AuthService,
      private toastr : ToastrService,
      private router : Router
    ){

    }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      username : ['', Validators.required],
      password : ['', Validators.required]
    })
  }

  doLogin(){
    this.loading.update(val => true)
    this.loginSubscription = this.authService.login(this.loginForm.value)?.subscribe({
      next : (res) =>{
        this.loading.update(val => false)
        this.authService.saveCurrentUser(res)
        this.router.navigateByUrl("/home")
      },
      error : (err) =>{
         this.loading.update(val => false)
        this.toastr.error(err?.error?.message)
      }
    })
  }

  openForgetPassword(){

  }

  ngOnDestroy(): void {
    //this.loginSubscription.unsubscribe()
  }
}
